/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {HasPublishedScheduleRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {HasPublishedScheduleResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const hasPublishedSchedule = (request: HasPublishedScheduleRequest, options?: CashRequestOptions) => post<HasPublishedScheduleRequest, HasPublishedScheduleResponse>("/2.0/cash/has-published-schedule", request, {...options, rejectOnError: true })